import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface DetailPageLayoutProps {
  /** Back button label and destination */
  backLabel: string;
  backTo: string;
  /** Page header: avatar/icon, title, badges */
  header: React.ReactNode;
  /** Left column (1/4 width) — typically an info sidebar card */
  sidebar: React.ReactNode;
  /** Center column (2/4 width) — main content */
  main: React.ReactNode;
  /** Right column (1/4 width) — supplementary cards */
  aside?: React.ReactNode;
}

export function DetailPageLayout({
  backLabel,
  backTo,
  header,
  sidebar,
  main,
  aside,
}: DetailPageLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4 p-6">
      {/* Back + header */}
      <div className="flex items-center gap-3 flex-wrap">
        <Button variant="ghost" size="sm" onClick={() => navigate(backTo)}>
          <ArrowLeft className="h-4 w-4 mr-1" />
          {backLabel}
        </Button>
        {header}
      </div>

      {/* 3-column grid */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-5">
        <div className="lg:col-span-1">{sidebar}</div>
        <div className="lg:col-span-2">{main}</div>
        {aside && <div className="lg:col-span-1 space-y-4">{aside}</div>}
      </div>
    </div>
  );
}
